<template>
  <Transition name="update-banner">
    <div v-if="updateAvailable" class="update-banner" :class="{ 'is-mobile': isMobile }">
      <div class="message">
        {{ localize('app.update.message') }}
      </div>
      <div class="actions">
        <gam-button v-bind="reloadButton" />
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { localize } from '@/core/gambits';
import { isMobile } from '@/core/helpers/ui.helper';
import GamButton from '@/views/components/GamButton.vue';
import { GamButtonSize, GamButtonVariant } from '@/views/composables/constants/components/gamButton.constants';
import { useAppUpdate } from '@/views/composables/hooks/useAppUpdate';
import type { GamButtonType } from '@/views/composables/models/components/GamButton';
import { computed } from 'vue';

const { updateAvailable, reload, isReloading } = useAppUpdate();

const reloadButton = computed((): GamButtonType => {
  return {
    variant: GamButtonVariant.SECONDARY,
    size: GamButtonSize.SMALL,
    isCentered: true,
    label: 'app.update.reload',
    onClick: reload,
    isLoading: isReloading.value,
  };
});
</script>

<style scoped lang="scss">
.update-banner {
  display: flex;
  align-self: center;
  z-index: 10000;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background: var(--color-dark-1000);
  border-bottom: 1px solid var(--color-white-10);
  justify-content: center;
  gap: var(--spacing-l);
  padding: 14px 48px;
  align-items: center;
}

.update-banner.is-mobile {
  gap: 12px;
  padding: 14px 24px;
}

.message {
  color: var(--color-white-100);
  font-size: 14px;
  font-weight: 400;
  line-height: 110%;
  align-self: center;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: center;
}

.update-banner-enter-active,
.update-banner-leave-active {
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}

.update-banner-enter-from,
.update-banner-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
